import { forwardRef, type Ref, type SVGProps } from "react";
const IconDeleteFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27 6h-5.382l-1.447-2.894A1.99 1.99 0 0 0 18.382 2h-4.764a1.99 1.99 0 0 0-1.789 1.105L10.382 6H5a1 1 0 0 0 0 2h1v20a2.006 2.006 0 0 0 2 2h16a2.006 2.006 0 0 0 2-2V8h1a1 1 0 0 0 0-2M14 25a1 1 0 0 1-2 0V11a1 1 0 0 1 2 0Zm6 0a1 1 0 0 1-2 0V11a1 1 0 0 1 2 0ZM13.618 4h4.764l1 2h-6.764Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconDeleteFilledSVG);
ForwardRef.displayName = "IconDeleteFilled";
export { ForwardRef as IconDeleteFilled };
